<template>
  <div>
    <b-alert
      v-for="(alert, i) in alerts"
      :key="i"
      :variant="alert.type"
      dismissible
      :show="alert.show && alert.timeout"
      @dismissed="closeAlert(i)"
      @dismiss-count-down="countDown($event, i)"
    >
      {{ alert.message }}
    </b-alert>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      dismissCountDown: 5
    };
  },
  computed: {
    ...mapGetters(["alerts"])
  },
  methods: {
    countDown(value, i) {
      this.alerts[i].timeout = value;
    },
    closeAlert(i) {
      this.alerts[i].show && (this.alerts[i].show = false);
      this.alerts[i].timeout = 0;
      this.$store.dispatch("CLOSE_ALERT", i);
    }
  }
};
</script>

<style></style>
